.page {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: center;
  min-height: 60dvh;
  text-align: center;
}

.title {
  font-size: 24px;
  margin: 0;
}

.link {
  color: inherit;
  text-decoration: underline;
}
